export const INDEX_PROJECTS_ATTEMPT = 'INDEX_PROJECTS_ATTEMPT';
export type INDEX_PROJECTS_ATTEMPT = typeof INDEX_PROJECTS_ATTEMPT;

export const INDEX_PROJECTS_SUCCESS = 'INDEX_PROJECTS_SUCCESS';
export type INDEX_PROJECTS_SUCCESS = typeof INDEX_PROJECTS_SUCCESS;

export const INDEX_PROJECTS_FAILURE = 'INDEX_PROJECTS_FAILURE';
export type INDEX_PROJECTS_FAILURE = typeof INDEX_PROJECTS_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/index/Types.tsx